import { render } from "./MenuContentItemValueRadio.vue?vue&type=template&id=38a2675a"
import script from "./MenuContentItemValueRadio.vue?vue&type=script&lang=js"
export * from "./MenuContentItemValueRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__